export const BILLING_CORRECTION_JIRA_URL =
  'https://tinuiti.atlassian.net/servicedesk/customer/portal/221/group/800/create/4095?xpis=eyJicmlkZ2UiOiJzbWFydExpbmtzIiwiaWQiOiIxNzg4NDQyNzI3MDUzIiwic291cmNlIjoiamlyYS1KU1cifQ%3D%3D';
